/** 매출 > 사용내역서 엔티티 */
export default class InvoiceUseHistory {
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
